import { el } from "../lib/dom";

export function starRow(filled: number, total = 3, size = "1rem"): HTMLElement {
  const row = el("div.stars");
  for (let i = 0; i < total; i++) {
    const s = el(`span.star${i < filled ? ".on" : ""}`, {}, i < filled ? "★" : "☆");
    s.style.fontSize = size;
    row.append(s);
  }
  return row;
}

let toastTimer: ReturnType<typeof setTimeout> | null = null;
export function toast(message: string): void {
  let t = document.querySelector<HTMLElement>(".toast");
  if (!t) {
    t = el("div.toast");
    document.body.append(t);
  }
  t.textContent = message;
  t.classList.add("show");
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t?.classList.remove("show"), 2200);
}

export interface ModalButton {
  label: string;
  primary?: boolean;
  onClick: () => void;
}

export function modal(opts: {
  title: string;
  body?: Node | string;
  buttons: ModalButton[];
}): () => void {
  const card = el("div.modal-card");
  card.append(el("h2.modal-title", {}, opts.title));
  if (opts.body) card.append(opts.body instanceof Node ? opts.body : el("p.modal-body", {}, opts.body));
  const actions = el("div.modal-actions");
  for (const b of opts.buttons) {
    actions.append(
      el(`button.btn${b.primary ? ".primary" : ""}`, { onclick: () => b.onClick() }, b.label),
    );
  }
  card.append(actions);
  const back = el("div.modal-backdrop", {}, card);
  document.body.append(back);
  requestAnimationFrame(() => back.classList.add("show"));
  return () => {
    back.classList.remove("show");
    setTimeout(() => back.remove(), 200);
    window.dispatchEvent(new Event("logika:modal-closed"));
  };
}
